import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth.service'
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../../services/config/config.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-lob-landing',
  templateUrl: './lob-landing.component.html',
  styleUrls: ['./lob-landing.component.css']
})
export class LobLandingComponent implements OnInit {

  authorized = true;
  lob: string;
  configRole: string;
  wallRole: string;
  configRoute: string;
  wallRoute: string;
  friendlyLOB = {
    life: 'Life',
    fnol: 'FNOL',
    health: 'Health',
    auto: 'Auto',
    claims: 'Claims',
    hr: 'HR',
    pnc: 'PNC',
    insidesales: 'Inside Sales',
    it: 'IT',
    aacc: 'AACC',
  }
  orderLife: any;

  constructor(
    private route: ActivatedRoute,
    public auth: AuthService,
    private configService: ConfigService,
    private router : Router
  ) { }

  ngOnInit() {
    this.lob = this.configService.activeLOB;
    this.wallRole = environment.roles[this.lob].wb;
    this.configRole = environment.roles[this.lob].config;
    // this.wallRoute = `wallboard`;
    if (this.route.snapshot.queryParamMap.get('authorized') === 'false') {
      this.authorized = false;
    }  

    this.route.queryParams
    .pipe(filter(params => params['status'] !== undefined))
    .subscribe(params => {
      console.log(params); 
      this.orderLife = params['status'];
      console.log("orderLife", this.orderLife); 
      if(this.orderLife == 'true'){
        this.configRoute = `wallboard-life/config-life`;
        this.wallRoute = `wallboard-life`;
      }else{
        this.configRoute = `wallboard/config`;
        this.wallRoute = `wallboard`;
      }
    });       
  }

}
